var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6079,
    r: 20,
    fill: "url(#paint0_linear_101_1144)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6079,
    r: 20,
    fill: "url(#paint1_linear_101_1144)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6079,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1144)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6079,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1144)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9865 14.7235C20.5007 15.2091 20.1697 15.828 20.0356 16.5018C19.9015 17.1756 19.9702 17.874 20.233 18.5088C20.4959 19.1435 20.941 19.6861 21.5122 20.0678C22.0835 20.4495 22.755 20.6532 23.442 20.6532C24.1291 20.6532 24.8006 20.4495 25.3718 20.0678C25.9431 19.6861 26.3882 19.1435 26.6511 18.5088C26.9139 17.874 26.9826 17.1756 26.8485 16.5018C26.7144 15.828 26.3834 15.2091 25.8975 14.7235C25.2455 14.0738 24.3625 13.709 23.442 13.709C22.5216 13.709 21.6386 14.0738 20.9865 14.7235ZM25.5075 19.2444C25.099 19.6529 24.5785 19.9311 24.0119 20.0438C23.4453 20.1565 22.858 20.0987 22.3243 19.8776C21.7905 19.6565 21.3343 19.2821 21.0134 18.8018C20.6924 18.3214 20.5211 17.7567 20.5211 17.179C20.5211 16.6012 20.6924 16.0365 21.0134 15.5562C21.3343 15.0758 21.7905 14.7014 22.3243 14.4803C22.858 14.2592 23.4453 14.2014 24.0119 14.3141C24.5785 14.4268 25.099 14.705 25.5075 15.1135C26.0546 15.6616 26.3619 16.4045 26.3619 17.179C26.3619 17.9534 26.0546 18.6963 25.5075 19.2444Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4465 23.0878L28.9526 20.7362V13.1804C28.9526 13.1048 28.9226 13.0324 28.8692 12.979C28.8158 12.9257 28.7434 12.8957 28.6679 12.8957H27.0052V11.774C27.0052 11.6984 26.9753 11.626 26.9219 11.5726C26.8685 11.5193 26.7961 11.4893 26.7206 11.4893H14.1284C14.0529 11.4893 13.9805 11.5193 13.9271 11.5726C13.8737 11.626 13.8438 11.6984 13.8438 11.774V28.0187C13.8438 28.0942 13.8737 28.1666 13.9271 28.22C13.9805 28.2734 14.0529 28.3034 14.1284 28.3034H15.7939V29.4422C15.7939 29.5177 15.8239 29.5901 15.8773 29.6435C15.9307 29.6969 16.0031 29.7269 16.0786 29.7269H28.6736C28.7491 29.7269 28.8215 29.6969 28.8749 29.6435C28.9283 29.5901 28.9583 29.5177 28.9583 29.4422V24.46L29.5277 25.0095C29.6535 25.1358 29.803 25.236 29.9677 25.3044C30.1323 25.3727 30.3088 25.408 30.4871 25.408C30.835 25.4085 31.1692 25.2726 31.418 25.0294C31.4664 24.9816 31.5111 24.9302 31.5518 24.8757C31.7577 24.6171 31.8609 24.2915 31.8414 23.9616C31.822 23.6316 31.6813 23.3204 31.4465 23.0878ZM27.0052 14.0515V13.4565H28.3974V20.2095L28.3035 20.1212C28.251 20.0732 28.1824 20.0466 28.1113 20.0466C28.0402 20.0466 27.9716 20.0732 27.9191 20.1212L27.8394 20.1981L27.3725 19.7454C27.9292 18.8933 28.1932 17.8829 28.1243 16.8673C28.0555 15.8518 27.6576 14.8863 26.991 14.117C26.9979 14.0957 27.0027 14.0738 27.0052 14.0515ZM27.4494 20.5995L26.8601 21.1889L26.4501 20.7789C26.5554 20.6906 26.6608 20.5995 26.7604 20.4942C26.8601 20.3889 26.9512 20.2892 27.0451 20.1839L27.4494 20.5995ZM27.5832 17.1832C27.5818 18.1399 27.2488 19.0665 26.641 19.8053C26.0331 20.5441 25.188 21.0493 24.2495 21.235C23.311 21.4207 22.3371 21.2754 21.4938 20.8238C20.6504 20.3721 19.9896 19.6421 19.624 18.7581C19.2583 17.874 19.2104 16.8905 19.4884 15.9751C19.7664 15.0597 20.3531 14.2689 21.1486 13.7375C21.9441 13.206 22.8992 12.9667 23.8513 13.0603C24.8034 13.1539 25.6936 13.5746 26.3704 14.2508C26.7562 14.6352 27.0621 15.0923 27.2702 15.5956C27.4784 16.0989 27.5848 16.6385 27.5832 17.1832ZM14.4046 27.7426V12.0416H26.4529V13.5846C25.5533 12.8327 24.4046 12.4448 23.2332 12.4975C22.0619 12.5502 20.9527 13.0396 20.1241 13.8693C19.3137 14.6917 18.835 15.784 18.7796 16.9373C18.7241 18.0906 19.0959 19.2238 19.8237 20.1201C20.5516 21.0164 21.5844 21.6129 22.7245 21.7954C23.8645 21.9778 25.0319 21.7335 26.0031 21.1091L26.47 21.576L26.3903 21.6529C26.3377 21.7059 26.3081 21.7775 26.3077 21.8522C26.3086 21.8896 26.3169 21.9264 26.332 21.9606C26.3472 21.9948 26.3689 22.0257 26.396 22.0515L26.4529 22.1027V27.7426H14.4046ZM28.3974 29.166H16.3462V28.2863H26.7291C26.8046 28.2863 26.877 28.2563 26.9304 28.2029C26.9838 28.1495 27.0138 28.0771 27.0138 28.0016V22.5924L28.406 23.9077L28.3974 29.166ZM31.1248 24.5397C31.0922 24.5809 31.0571 24.6199 31.0195 24.6564C30.8676 24.7966 30.6668 24.8716 30.4602 24.8652C30.2536 24.8588 30.0578 24.7716 29.9148 24.6223L26.9825 21.8522L28.1213 20.7134L28.48 21.0494L31.0622 23.4863C31.1975 23.6233 31.2784 23.8048 31.2899 23.997C31.3014 24.1892 31.2428 24.379 31.1248 24.5312V24.5397Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2013 22.4531H16.654C16.5924 22.4686 16.5378 22.5041 16.4987 22.5541C16.4597 22.6042 16.4385 22.6658 16.4385 22.7293C16.4385 22.7927 16.4597 22.8544 16.4987 22.9044C16.5378 22.9545 16.5924 22.99 16.654 23.0054H24.2013C24.2628 22.99 24.3175 22.9545 24.3565 22.9044C24.3955 22.8544 24.4167 22.7927 24.4167 22.7293C24.4167 22.6658 24.3955 22.6042 24.3565 22.5541C24.3175 22.5041 24.2628 22.4686 24.2013 22.4531ZM24.2013 24.093H16.654C16.5924 24.1084 16.5378 24.144 16.4987 24.194C16.4597 24.244 16.4385 24.3057 16.4385 24.3691C16.4385 24.4326 16.4597 24.4942 16.4987 24.5443C16.5378 24.5943 16.5924 24.6299 16.654 24.6453H24.2013C24.2628 24.6299 24.3175 24.5943 24.3565 24.5443C24.3955 24.4942 24.4167 24.4326 24.4167 24.3691C24.4167 24.3057 24.3955 24.244 24.3565 24.194C24.3175 24.144 24.2628 24.1084 24.2013 24.093ZM24.2013 25.7243H16.654C16.5924 25.7397 16.5378 25.7753 16.4987 25.8253C16.4597 25.8753 16.4385 25.937 16.4385 26.0004C16.4385 26.0639 16.4597 26.1255 16.4987 26.1756C16.5378 26.2256 16.5924 26.2612 16.654 26.2766H24.2013C24.2628 26.2612 24.3175 26.2256 24.3565 26.1756C24.3955 26.1255 24.4167 26.0639 24.4167 26.0004C24.4167 25.937 24.3955 25.8753 24.3565 25.8253C24.3175 25.7753 24.2628 25.7397 24.2013 25.7243Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1144",
    x: 0.847312,
    y: 0.60791,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1144",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1144",
    x1: 38.7548,
    y1: 34.8277,
    x2: 26.6622,
    y2: -0.0639159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1144",
    x1: 5.10198,
    y1: 38.3497,
    x2: 40.5855,
    y2: 2.86614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1144",
    x1: 24.4598,
    y1: 40.6079,
    x2: 42.8267,
    y2: 21.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1144",
    x1: 0.84375,
    y1: 3.46505,
    x2: 29.7595,
    y2: 47.6273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAudit);
export default __webpack_public_path__ + "static/media/admin_audit.353eb923961a4c7e004b09170ea6804b.svg";
export { ForwardRef as ReactComponent };